<template>
  <div class="venueManage">
    <div class="dark-theme maxWidth">
      <el-form :inline="true" ref="formRef" :model="search_form" class="ant-advanced-search-form" size="small">
        <el-form-item label="场馆名称" class="search_item">
          <el-input v-model="search_form.venueName" placeholder="请输入场馆名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="" class="mr-10" icon="el-icon-refresh" @click="operation('reset')">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="operation('search')">查询</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="operation('add')">新增场馆</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="venueList" row-key="id" class="mt20" >
        <el-table-column label="编号" align="center" type="index" width="80" />
        <el-table-column prop="venueName" label="场馆名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="venueAddress" label="场馆地址" >
          <template slot-scope="scope">
            {{ scope.row.province }}/{{ scope.row.city }}/{{ scope.row.area }} {{ scope.row.venueAddress }}
          </template>
        </el-table-column>
        <el-table-column label="添加人" align="center" prop="createBy" ></el-table-column>
        <el-table-column label="添加时间" align="center" prop="createTime" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime && moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" plain @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :page.sync="search_form.pageNum" :limit.sync="search_form.pageSize" @pagination="_getList" />
    </div>


    <!-- 添加/编辑场馆 -->
    <a-modal :title="venueTitle" width="600px" :visible.sync="showDialog">
      <el-form :model="venueForm" :rules="rules"  ref="venueRef" label-width="80px" class="px20">
        <el-form-item label="场馆名称" name="venueName" prop="venueName" >
          <a-input
            size="large"
            v-model="venueForm.venueName"
            autocomplete="off"
            placeholder="请输入场馆名称"
          />
        </el-form-item>
        <el-form-item label="场馆地址" name="region"  prop="region">
          <a-cascader
            v-model="venueForm.region"
            :field-names="{ label: 'name', value: 'code', children: 'areaList' }"
            :options="areaList"
            placeholder="请选择省市区"
            @change="venueChange"
          />
        </el-form-item>
        <el-form-item label="" name="venueAddress" prop="venueAddress">
          <a-textarea
            ref="cityTree"
            v-model="venueForm.venueAddress"
            placeholder="输入详细地址"
            show-count
            :rows="4"
            :maxlength="200"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="subAddAddress">确 定</el-button>
      </div>
    </a-modal>

  </div>
</template>

<script>
import moment from "moment";
import { Modal } from "ant-design-vue";
export default {
  data(){
    return {
      search_form: {
        pageNum: 1,
        pageSize: 10,
        venueName: '',
      },
      loading: false,
      venueList: [],
      total: 0,

      showDialog: false,
      venueTitle: '新增场馆',
      venueForm: {
        region: [],
        venueName: '',
        venueAddress: '',
      },
      rules: {
				venueName: [{ required: true, message: "请输入场馆名称", trigger: "blur", }],
				region: [{ required: true, message: "请选择省市区", trigger: "change", }],
				venueAddress: [{ required: true, message: "请输入详细地址", trigger: "blur", }],
      },
      areaList: this.$store.state.areaList,
      fileladName: {
        label: "name",
        value: "code",
        children: "areaList",
      },

    }
  },
  computed: {
    changeTime(){
      return function(time, type){
        type = type ? type : 'YYYY-MM-DD hh:mm:ss'
        return moment(time).format(type)
      }
    },
    videoTime(){
      return function(mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = parseInt((mss % (1000 * 60)) / 1000);
        if (days > 0) {
          return `${days}天${hours<10 ? '0'+hours : hours}小时${minutes<10 ? '0'+minutes : minutes}分钟${seconds<10 ? '0'+seconds : seconds}秒`
        }
        if (hours > 0) {
          return `${hours<10 ? '0'+hours : hours}:${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
        }
        return `${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
      }
    },
    moment: () => moment,
  },
  methods: {
    moment,
    _getList() {
      this.$axios.get('/api/qhd/Venue/findVenue', this.search_form).then(res=>{
        if (res.code == 200) {
          this.venueList = res.data.list
          this.total = res.data.total
        }
      })
    },
    reset(form) {
      for (let key in form) {
        form[key] = null;
      }
    },
    refreshList() {
      this.search_form.pageNum = 1
      this.search_form.venueName = ''
      this._getList()
    },
    selectName(e, value) {
      console.log(value)
      value.forEach((ele) => {
        console.log(ele);
        this.newAddress.name.push(ele.name);
      });
    },
    subAddAddress() {
      this.$refs["venueRef"].validate((valid) => {
        if (valid) {
          this.subAddressApi();
        } else {
          return false;
        }
      });
    },
    
    operation(type){
      switch(type) {
        case 'search':
          this.search_form.pageNum = 1
          this._getList()
          break;
        case 'reset':
          this.refreshList()
          break;
        case 'add':
          this.venueTitle = '新增场馆'
          this.showDialog = true
          this.venueForm = {}
          break;
      }
    },
    handleDel(e) {
      console.log(e);
      Modal.confirm({
        title: "操作确认",
        content: `确定删除该场馆？`,
        onOk: () => {
          this._delVenue(e)
        },
        onCancel() {},
      });
    },
    _delVenue(e) {
      this.$axios.get("/api/qhd/Venue/delVenue", { id: e.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.refreshList()
        }
      });
    },

    subAddressApi() {
      let params = {
        ...this.venueForm
      }
      params.provinceId = this.venueForm.region[0]
      params.cityId = this.venueForm.region[1]
      params.areaId = this.venueForm.region[2]
      if(!params.venueTimeList) params.venueTimeList = []
      let apiUrl = params.id ? '/api/qhd/Venue/updateVenue' : '/api/qhd/Venue/addVenue'
      this.$axios.post(apiUrl, params).then((res) => {
        if (res.code == 200) {
          this.showDialog = false;
          this.$message.success( params.id ? "编辑成功" : "场馆添加成功");
          setTimeout(() => {
            this._getList();
          }, 1000);
        }
      });
    },
    handleEdit(e) {
      console.log(e);
      console.log(this.areaList);
      console.log(this.$store.state)
      this.venueForm = JSON.parse(JSON.stringify(e))
      this.venueForm.region = e.provinceId&&e.cityId&&e.areaId ? [e.provinceId.toString(),e.cityId.toString(),e.areaId.toString()] : []
      this.venueTitle = '编辑场馆'
      this.showDialog = true
    },
    venueChange(e) {
      console.log(e);
      this.venueForm.region = e
      this.$forceUpdate()
      this.getName(e)
    },
    getName(arr) {
      // console.log(this.areaList);
      if(arr.length) {
        for (let i = 0; i < this.areaList.length; i++) {
          const pro = this.areaList[i];
          if(pro.code == arr[0]) {
            // console.log(pro);
            this.venueForm.province = pro.name
            for (let j = 0; j < pro.areaList.length; j++) {
              const city = pro.areaList[j];
              if(city.code == arr[1]) {
                // console.log(city);
                this.venueForm.city = city.name
                for (let k = 0; k < city.areaList.length; k++) {
                  const area = city.areaList[k];
                  if(area.code == arr[2]) {
                    this.venueForm.area = area.name
                  }
                }
              }
            }
          }
        }
      }
      console.log(this.venueForm);
    }
  },
  created(){
    this._getList()
  }
}
</script>

<style lang="less" scoped>

.uploader{
  display: block;
  width: 130px;
  height: 130px;
  background: var(--form-bg-color);
  border-radius: 4px;
  text-align: center;
  line-height: 130px;
}
.venueIndex{
  background: var(--bg-color);
}
.search_box, .content{
  background: var(--dark-color);
  padding: 10px;
  margin-bottom: 16px;
}
.search_item{
  margin-bottom: 25px;
  .date_content{
    color: #999;
    margin: 0 16px;
  }
}

</style>
<style lang="less">
.venueManage {
  .el-table th {
    color: #BCBCBC;
    background-color: #21284b !important;
  }
  .el-table__body {
    background-color: #0f132a;
  }
}

table .ant-btn-dangerous {
  background-color: unset !important;
}
</style>